import React, { Component } from "react";
import { Card, CardBody, Progress, FormText } from "reactstrap";
import NotificationSystem from "react-notification-system";
import {
  apiActions,
  alertActions,
  commonActions,
  modalActions,
} from "../../_actions";
import { appConstants, alertConstants } from "../../_constants";
import { appHelpers, store } from "../../_helpers";
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import PageEmptyContent from "../utils/page.empty-content";
import { connect } from "react-redux";
import { operationsService } from "../../_services/operations.service";
import ViewHeader from "./view-header";
import SearchPanel from "./flightOperations-panel";
import moment from "moment";
import ReportIcon from "react-icons/lib/md/landscape";
import PaginatedResult from "./record";

const ViewContent = ({ children }) => (
  <div className="view-content view-components">{children}</div>
);

class FlightOperation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      airlines: [],
      desAirports: [],
      depAirports: [],
      records: [],
      dialogTitle: "",
      airlineValue: null,
      desValue: null,
      selectValue: { label: "Airline", value: "AirlineId" },
      startDate: new Date(),
      endDate: new Date(),
      //page error
      contentError: false, //Errors that affect content on the page
      componentError: false, //Errors generated within the component
      componentErrorMessages: [], //Errors generated within the component form
      error: false, //Error state mutable via Redux
      success: false, //Success message mutable via Redux
      //Notification
      notification: {
        // title: 'Default Title',
        message: "Default Message",
        level: "success",
        position: "tr",
        dismissible: true,
      },
      //Pagination
      pageSize: 10,
      currentPage: 0,
      totalCount: 0,
    };
    this._notificationSystem = null;
    this._lastNotificationAdded = null;
  }

  componentWillReceiveProps = function (nextProps) {
    const { alert } = nextProps;
    if (alert) {
      if (alert.type === alertConstants.SUCCESS) {
        this.setState({ error: false, success: "Operation successful" });
        this.resetForm();
      } else if (alert.type === alertConstants.CLEAR) {
        this.setState({ success: false, error: false });
      } else {
        this.setState({ success: false, error: alert.message });
      }
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.airlinesCarriers !== this.props.airlinesCarriers) {
      this.setState({
        airlines: this.formatAirlines(this.props.airlinesCarriers.Results),
      });
    }
  }

  resetError() {
    this.props.dispatch(modalActions.clear());
    this.props.dispatch(alertActions.clear());
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    //    Fetch Airlines
    const reduxState = store.getState();
    const { user } = this.props;
    // debugger;
    if (reduxState.airlinesCarriers) {
      this.setState(
        { airlines: this.formatAirlines(reduxState.airlinesCarriers.Results) },
        () => {
          if (user && this.state.airlines) {
            // debugger;
            const fetch = this.state.airlines.filter((item, index) => {
              return item.Id === user.AirlineId;
            });
            if (Array.isArray(fetch)) {
              this.setState({ airlineValue: fetch[0] }, () => {
                if (this.state.airlineValue) {
                  this.fetchAirlineFlightNumbers(this.state.airlineValue.Id);
                }
              });
            }
          }
        }
      );
    } else {
      this.fetchAirlines();
    }
  }

  notify = (message, level) => {
    let notification = this.state.notification;
    notification["message"] = message;
    notification["level"] = level;
    notification.onRemove = this.onRemove;
    this._lastNotificationAdded =
      this._notificationSystem.addNotification(notification);
  };

  // API CALLS
  fetchAirlines = () => {
    const { dispatch, user } = this.props;
    this.setState({ contentError: false });
    dispatch(apiActions.startFullPageRequest());

    dispatch(commonActions.getAirlinesCarriers())
      .then(() => {
        const { airlinesCarriers } = this.props;
        this.setState(
          { airlines: this.formatAirlines(airlinesCarriers.Results) },
          () => {
            if (user && this.state.airlines) {
              // debugger;
              const fetch = this.state.airlines.filter((item, index) => {
                return item.Id === user.AirlineId;
              });
              if (Array.isArray(fetch)) {
                this.setState({ airlineValue: fetch[0] }, () => {
                  if (this.state.airlineValue) {
                    this.fetchAirlineFlightNumbers(this.state.airlineValue.Id);
                  }
                });
              }
            }
          }
        );
        //this.formatAirlines(res.data.Results);
        dispatch(apiActions.endRequest());
      })
      .catch((error) => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        this.setState({ contentError: errorMessage });
        dispatch(apiActions.endRequest());
      });
  };

  search = (pageNumber = 1) => {
    const { dispatch } = this.props;
    const { pageSize, startDate, airlineValue, endDate } = this.state;

    this.setState({ contentError: false });

    dispatch(apiActions.startFullPageRequest());

    let payload = {
      PageSize: pageSize,
      From: pageNumber - 1,
      Parameter: {
        AirlineId: airlineValue && airlineValue.Id ? airlineValue.Id : "",
        StartDate: moment(startDate).format("YYYY-MM-DD") + "T00:00:00",
        EndDate: moment(endDate).format("YYYY-MM-DD") + "T23:59:59",
        IsLocal:
          airlineValue && airlineValue.IsLocal ? airlineValue.IsLocal : "",
      },
    };

    operationsService
      .getFlightOperations(payload)
      .then((res) => {
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          const response = res.response;
          this.setState({
            records: response.Results || [],
            currentPage: pageNumber,
            totalCount: response.Count || 0,
          });
        } else if (res.status === appConstants.ERROR_RESPONSE) {
          dispatch(
            alertActions.error(
              appHelpers.interpretErrorResponseAlt2(res.response.Message)
            )
          );
        }
        dispatch(apiActions.endRequest());
      })
      .catch((err) => {
        dispatch(
          alertActions.error(appHelpers.interpretErrorResponseAlt2(err))
        );
        dispatch(apiActions.endRequest());
      });
  };

  downloadPdfAndExcel = (DownloadTypeId, pageNumber = 1) => {
    const { dispatch } = this.props;
    const { airlineValue, selectValue, pageSize, startDate, endDate } =
      this.state;
    let fromPage = pageSize * (pageNumber - 1);

    let payload = {
      PageSize: pageSize,
      From: fromPage,
      Parameter: {
        AirlineId: airlineValue && airlineValue.Id ? airlineValue.Id : "",
        IsLocal:
          airlineValue && airlineValue.IsLocal ? airlineValue.IsLocal : "",
        StartDate: moment(startDate).format("YYYY-MM-DD") + "T00:00:00",
        EndDate: moment(endDate).format("YYYY-MM-DD") + "T23:59:59",
      },
    };

    dispatch(apiActions.startRequest());

    operationsService
      .flightOperationsDownload(payload, DownloadTypeId)
      .then((res) => {
        console.log(res, "redata");

        if (res.status === appConstants.SUCCESS_RESPONSE) {
          console.log(res, "res");
          let response = res.response.data;
        
          console.log(response, "report data");
          console.log("is Blob?", response instanceof Blob);
          console.log("mime type from server:", response.type);
          const isBase64 = response.base64File ? true : false;
          const fileData = response.base64File || response;
        
          const mimeType = appHelpers.getMimeTypeFromType(DownloadTypeId);
        console.log(mimeType, "mime type");
          appHelpers.downloadFileV2(fileData, "Report", isBase64, mimeType);
        }
        dispatch(apiActions.endRequest());
      })
      .catch((error) => {
        dispatch(alertActions.error("Download failed"));
        dispatch(apiActions.endRequest());
      });
  };
  


  //modals toggle

  handleAirlineChange = (selectedAirline) => {
    this.setState({
      airlinesId: selectedAirline ? selectedAirline.Id : "",
      airlineValue: selectedAirline, // Update airlineValue too
      contentErrorText: false,
    });
  };

  //HANDLERS

  formatAirlines = (res) => {
    let data = [];

    for (let item of res) {
      item["cat"] = "AirlineId";
      item["label"] = `${item.Name} (${item.Code})`;
      item["value"] = item.Id;
      data.push(item);
    }

    return data;
  };

  resetForm() {
    this.setState({
      componentError: false,
    });
    this.resetError();
  }

  changeDatePicker = (date, target) => {
    this.setState({ [target]: date });
  };

  renderPageResponse = () => {
    if (this.state.error) {
      return <div className="alert alert-danger">{this.state.error}</div>;
    } else if (this.state.componentError) {
      return (
        <div className="alert alert-danger">{this.state.componentError}</div>
      );
    } else if (this.state.success) {
      return <div className="alert alert-success">{this.state.success}</div>;
    }
  };

  validateInput = () => {
    let _errs_ = [];
    let formValid = true;
    if (this.state.airlineValue === undefined) {
      _errs_["airlineValue"] = "Please select an airline";
      formValid = false;
    }

    if (this.state.startDate === "") {
      _errs_["startDate"] = "Please select a date";
      formValid = false;
    }

    this.setState({ componentErrorMessages: _errs_ });
    return formValid;
  };

  render() {
    let modalResponse = this.renderPageResponse();

    const {
      contentError,
      currentPage,
      pageSize,
      airlines,
      records,
      totalCount,
      airlineValue,
      componentErrorMessages,
    } = this.state;

    const { requesting, pageRequesting } = this.props;
    return (
      <div className="view">
        <ViewHeader />
        <ViewContent>
          <Card className="mb-4">
            {/*Progress bar for Pending API Request*/}
            {(pageRequesting || requesting) && !pageRequesting && (
              <Progress
                striped
                animated
                color="success"
                value={100}
                className="mb-2"
              />
            )}
            {/*Display loader when component content is dependent on Data from API*/}
            {!contentError && pageRequesting && <PageLoading />}

            {/*Display error when component fail to get Data from API*/}
            {contentError && <PageError error={this.state.contentError} />}

            {/* {!pageRequesting && error && (
                            <ComponentPageError error={error} />
                        )} */}
            {/*Display component content when Data is gotten from API*/}
            {!contentError && !pageRequesting && (
              <CardBody>
                <h6 className="mb-0 text-uppercase pull-left">
                  SEARCH BY FLIGHT
                </h6>
                <div className="clearfix">&nbsp;</div>
                <SearchPanel
                  airlines={airlines}
                  user={this.props.user}
                  airlineValue={airlineValue}
                  componentErrorMessages={componentErrorMessages}
                  handleSelectChange={this.handleSelectChange}
                  handleAirlineChange={this.handleAirlineChange}
                  onSearch={this.search}
                  startDateChange={(startDate) => this.setState({ startDate })}
                  endDateChange={(endDate) => this.setState({ endDate })}
                />
                <hr />

                <CardBody>
                  {!pageRequesting && records && records.length > 0 && (
                    <div>
                      <PaginatedResult
                        records={records}
                        currentPage={currentPage}
                        navigate={this.search}
                        pageSize={pageSize}
                        totalCount={totalCount}
                        downloadExcel={() => this.downloadPdfAndExcel(1)}
                        downloadPdf={() => this.downloadPdfAndExcel(2)}
                      />
                    </div>
                  )}
                  {!pageRequesting && records.length === 0 && (
                    <PageEmptyContent message="No record match your search!" />
                  )}
                </CardBody>
              </CardBody>
            )}
            <NotificationSystem ref="notificationSystem" />
          </Card>
        </ViewContent>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { loggingIn, user } = state.authentication;
  const { pageRequesting, requesting } = state.api;
  const { alert, modal, entities, airlines, airlinesCarriers } = state;
  return {
    loggingIn,
    requesting,
    pageRequesting,
    alert,
    modal,
    entities,
    airlines,
    airlinesCarriers,
    user,
  };
}

export default connect(mapStateToProps)(FlightOperation);



// WEBPACK FOOTER //
// ./src/views/flight-operations/index.js